var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTxt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 72,
    viewBox: "0 0 51 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7744 11.1874H43.766C43.6171 10.9392 43.4185 10.691 43.1703 10.4428L35.278 2.55048C35.0795 2.35193 34.8313 2.15338 34.5334 1.95483V9.89681C34.5334 10.6414 35.0795 11.1874 35.7744 11.1874Z",
    fill: "#119AF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7745 14.5131C33.243 14.5131 31.2078 12.4779 31.2078 9.94642V1.25989H10.8069C9.61559 1.25989 8.52357 1.70662 7.67973 2.55046C6.8359 3.39429 6.38916 4.48631 6.38916 5.67761V43.948C6.38916 46.3802 8.37465 48.3657 10.8069 48.3657H40.0433C42.4755 48.3657 44.461 46.3802 44.461 43.948V14.5131H35.7745ZM36.7176 40.3741C36.7176 40.7712 36.3701 41.1187 35.973 41.1187H14.8771C14.48 41.1187 14.1326 40.7712 14.1326 40.3741V38.4383C14.1326 38.0412 14.48 37.6937 14.8771 37.6937H35.973C36.3701 37.6937 36.7176 38.0412 36.7176 38.4383V40.3741ZM36.7176 32.2336C36.7176 32.6307 36.3701 32.9781 35.973 32.9781H14.8771C14.48 32.9781 14.1326 32.6307 14.1326 32.2336V30.2977C14.1326 29.9006 14.48 29.5532 14.8771 29.5532H35.973C36.3701 29.5532 36.7176 29.9006 36.7176 30.2977V32.2336ZM36.7176 24.0931C36.7176 24.4902 36.3701 24.8376 35.973 24.8376H14.8771C14.48 24.8376 14.1326 24.4902 14.1326 24.0931V22.1572C14.1326 21.7601 14.48 21.4126 14.8771 21.4126H35.973C36.3701 21.4126 36.7176 21.7601 36.7176 22.1572V24.0931Z",
    fill: "#119AF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxt);
export default __webpack_public_path__ + "static/media/txt.25fba9a1e41dfd24ebf403ed98c19ba3.svg";
export { ForwardRef as ReactComponent };